import React from 'react';
import { FooterSocial } from './footer/FooterSocial';
import { FooterQuickLinks, FooterServices } from './footer/FooterLinks';
import { FooterContact } from './footer/FooterContact';
import { FooterBottom } from './footer/FooterBottom';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_finance-advisory-9/artifacts/brkbasw5_AssetWise%20Logo_CMYK-01.jpg';

const Footer = () => (
  <footer className="bg-gray-900 text-gray-300" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="grid md:grid-cols-4 gap-8 mb-8">
        <div className="md:col-span-1">
          <img src={LOGO_URL} alt="AssetWise" className="h-12 w-auto mb-4" />
          <p className="text-sm text-gray-400 leading-relaxed">
            Your trusted partner for loans, real estate, and legal advisory services. Making financial dreams a reality.
          </p>
          <FooterSocial />
        </div>

        <FooterQuickLinks />
        <FooterServices />
        <FooterContact />
      </div>

      <FooterBottom year={new Date().getFullYear()} />
    </div>
  </footer>
);

export default Footer;
